import React from 'react';

import { Container, Stack, Box } from '@mui/material';

import Link from '../Link';

import PrefersDarkMode from '../lib/prefersDarkMode';

const Navigation = ({ logoBlack, logoWhite, pages = [], siteUrl }) => {
  const NavigationLink = ({ to, label, partiallyActive }) => {
    return (
      <Link
        sx={{
          color: 'text.primary',
          lineHeight: {
            xs: 2,
            sm: 3,
            md: 4,
          },
          margin: {
            sm: 0,
            md: '0 0 0 40px',
          },
          textTransform: 'uppercase',
          paddingX: {
            xs: 1,
            sm: 2,
            md: 'inherit',
          },
        }}
        variant="button"
        to={to}
        underline="none"
        activeStyle={{ fontWeight: 'bold' }}
        partiallyActive={partiallyActive}
      >
        {label}
      </Link>
    );
  };

  return (
    <>
      <Box
        sx={{
          backgroundColor: 'background.paper',
          position: 'sticky',
          top: 0,
          width: '100%',
          zIndex: '90',
        }}
      >
        <Container maxWidth="lg">
          <Stack
            direction="row"
            spacing={2}
            sx={{
              justifyContent: 'flex-end',
              alignItems: 'center',
              paddingY: 0.5,
            }}
          >
            <Link
              variant="ButtonNavigationTop"
              sx={{ fontWeight: siteUrl.includes('pielaco.com') ? 'bold' : 'inherit' }}
              color="text.secondary"
              underline="none"
              target="_blank"
              rel="noopener"
              to="https://pielaco.com"
            >
              Piela & Co.
            </Link>

            <Link
              variant="ButtonNavigationTop"
              sx={{ fontWeight: siteUrl.includes('insurancemedia.de') ? 'bold' : 'inherit' }}
              color="text.secondary"
              underline="none"
              target="_blank"
              rel="noopener"
              to="https://insurancemedia.de/"
            >
              Insurance Media
            </Link>

            <Link
              variant="ButtonNavigationTop"
              color="text.secondary"
              underline="none"
              target="_blank"
              rel="noopener"
              to="https://digital-insurance-jobs.com/"
            >
              Digital Insurance Jobs
            </Link>
            <Link
              variant="ButtonNavigationTop"
              color="text.secondary"
              underline="none"
              target="_blank"
              rel="noopener"
              to="https://newdatscha.de"
            >
              NewDatscha
            </Link>
          </Stack>
        </Container>
      </Box>

      <Box
        sx={{
          backgroundColor: 'background.default',
          position: 'sticky',
          top: 0,
          width: '100%',
          zIndex: '100',
          boxShadow: 2,
        }}
      >
        <Container maxWidth="lg">
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={0}
            alignItems="center"
            justifyContent="space-between"
          >
            <Box
              sx={{
                margin: {
                  sm: 0,
                },
                paddingTop: {
                  xs: 1,
                },
                img: {
                  height: '32px',
                },
              }}
            >
              <Link to={pages[0]?.to}>
                <img
                  src={PrefersDarkMode() ? logoWhite : logoBlack}
                  alt="Piela & Co Logo"
                />
              </Link>
            </Box>
            <Box
              sx={{
                display: 'flex',
                flexWrap: 'wrap',
                justifyContent: { xs: 'center', md: 'flex-end' },
              }}
            >
              {pages.map(({to, label, partiallyActive}) => (
                <NavigationLink
                  key={label}
                  to  ={to}
                  label={label}
                  partiallyActive={partiallyActive}
                />
              ))}
            </Box>
          </Stack>
        </Container>
      </Box>
    </>
  );
};

export default Navigation;
